import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { catchError, tap, map, first, concatMap, takeUntil } from 'rxjs/operators';
import { Subject, throwError } from 'rxjs';
import { HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { UserService } from '../services/api/user.service';
import { User } from '../models/user';
import { ParametersService } from '../services/api/parameters.service';
import { AuthentificationService } from '../services/api/authentification.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
	private ngUnsubscribe = new Subject();

	constructor(
		private router: Router, 
		private authService: AuthentificationService
		,private userService:UserService, private parametreService: ParametersService) { }

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		try {
			var IsConnected: boolean = false;
			var StatusCode : number = 0;
			return this.authService.isConnected().pipe(
				tap((resp: HttpResponseBase) => {
					IsConnected = resp.ok;
					StatusCode = resp.status;
					if (!IsConnected) {
						localStorage.removeItem("TOKEN");
						this.router.navigate(['']);
						if (window.location.href.includes("log")){
							localStorage.setItem("requestedUrl", window.location.href);
						}
						IsConnected = false;
						this.authService.setConnectionChecked(true);
					}
				})
				
				,concatMap(resp2 => this.userService.get())
				,tap((user: User) =>{
					this.userService.user = user
				})
				,concatMap(resp3 => this.parametreService.getBackOffice_ParametresPersonalisations())

				,concatMap(resp4 => this.parametreService.getManyCurrency())
				,tap(() =>{})
				
				// ,concatMap(resp3 => this.authorizationsService.getUser_Authorizations())
				// ,tap(() =>{})
				
				).pipe(takeUntil(this.ngUnsubscribe), map((resp: any) => {
				if (!IsConnected) {
					localStorage.removeItem("TOKEN");
					this.router.navigate(['']);
				}
				this.authService.setConnectionChecked(true);
				return IsConnected;
				}));
		} catch (ex) {
			this.router.navigate(['']);
			this.authService.setConnectionChecked(true);
			return false
		}
	}
}